const {LitElement, html, ref, createRef} = window.globalLit;
import BaseStepElement from './BaseStepElement.js';

customElements.define('type-step', class TypeStepElement extends BaseStepElement {

    selectorRef = createRef();

    render() {
        return html`
                <strong>Type </strong>
                    <input is="autogrow-input" type="text" 
                        placeholder="Value..."
                        .value=${this.value.text || ''}
                        ?readonly=${this.readonly}
                        @input="${this._onChange.bind(this, 'text')}"
                        style="min-width: 50px; width: 50px;"
                        class="step__input bg-primary-subtle text-primary">
        `;
    }
});